export default {
    values: {
        'An error has occurred while migrating old purge rules!':
            'Ocorreu um erro ao migrar as antigas regras de expurgo!',
        'Purge rules successfully migrated': 'Regras de expurgo migradas com sucesso',
        'Migrate old purge rules': 'Migrar antigas regras de expurgo'
    }
}
